// Plan 107: the IRS lock-in floor as the server applies it (server/services/w4ChangePolicyService.js floorViolations).
// A NULL floor column (incomplete floor: a row the migration backfill skipped, or a hand-edited one) is that field's
// CURRENT live W-4 value, not the loosest default - what is withheld today can't be lowered until the letter is
// re-saved as an IRS lock-in letter.
const isNull = (v) => v === null || v === undefined || v === '';
const num = (v) => Number(v || 0);

// [floor column, live column]
const PAIRS = [
  ['w4_lock_in_filing_status', 'filing_status'], ['w4_lock_in_multiple_jobs', 'w4_multiple_jobs'],
  ['w4_lock_in_dependent_credits', 'w4_dependent_credits'], ['w4_lock_in_other_income', 'w4_other_income'],
  ['w4_lock_in_deductions', 'w4_deductions'], ['w4_lock_in_extra_withholding', 'w4_extra_withholding'],
  ['w4_lock_in_allowances', 'federal_allowances'], ['w4_lock_in_additional_withholding', 'additional_federal_withholding'],
];

export function resolveW4Floor(row) {
  const r = row || {};
  const pick = (floorCol, liveCol) => (isNull(r[floorCol]) ? r[liveCol] : r[floorCol]);
  const bool = (v) => v === true || v === 'true' || v === 't';
  return {
    filing_status: pick('w4_lock_in_filing_status', 'filing_status') || 'single',
    multiple_jobs: bool(pick('w4_lock_in_multiple_jobs', 'w4_multiple_jobs')),
    dependent_credits: num(pick('w4_lock_in_dependent_credits', 'w4_dependent_credits')),
    other_income: num(pick('w4_lock_in_other_income', 'w4_other_income')),
    deductions: num(pick('w4_lock_in_deductions', 'w4_deductions')),
    // Extra Withholding and the pre-2020 Additional Federal Withholding are enforced as one sum.
    extra: num(pick('w4_lock_in_extra_withholding', 'w4_extra_withholding')) + num(pick('w4_lock_in_additional_withholding', 'additional_federal_withholding')),
    allowances: num(pick('w4_lock_in_allowances', 'federal_allowances')),
    incomplete: PAIRS.some(([floorCol]) => isNull(r[floorCol])),
  };
}
